import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import GoogleMapLink from './google_map_link';
import { generateTitle, sortPickUpDropOff } from './helpers';

const PickUpDropOff = ({ locations }) => {
  const { values, setFieldValue } = useFormikContext();

  // Handle Google Map Link updates
  const [pickUps, dropOffs] = sortPickUpDropOff(locations);
  const pickUpOption = pickUps?.options.find(
    (item) => item.id === values.pickUp
  );
  const dropOffOption = dropOffs?.options.find(
    (item) => item.id === values.dropOff
  );

  return (
    <>
      <div className="border-top">
        <h4 className="my-4">{generateTitle({ pickUps, dropOffs })}</h4>
        <span>
          Please note pick-up and drop-off times are approximate and can vary by
          up to 15 minutes.
        </span>
      </div>
      {pickUps && (
        <div className="py-4 space-y-2">
          <label className="fw-bold" htmlFor="pickUp">
            {pickUps.label}
          </label>
          <Field
            name="pickUp"
            id="pickUp"
            className="form-select"
            component="select"
            onChange={(event) =>
              setFieldValue('pickUp', Number(event.target.value))
            }
          >
            {pickUps.options
              .filter((option) => option.bookable_online === true)
              .map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
          </Field>
          <GoogleMapLink option={pickUpOption} />
        </div>
      )}
      {dropOffs && (
        <div className="pb-4 space-y-2">
          <label className="fw-bold" htmlFor="dropOff">
            {dropOffs.label}
          </label>
          <Field
            name="dropOff"
            id="dropOff"
            className="form-select"
            component="select"
            onChange={(event) =>
              setFieldValue('dropOff', Number(event.target.value))
            }
          >
            {dropOffs.options
              .filter((option) => option.bookable_online === true)
              .map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
          </Field>
          <GoogleMapLink option={dropOffOption} />
        </div>
      )}
    </>
  );
};

const optionShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
});

PickUpDropOff.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      options: PropTypes.arrayOf(optionShape),
    })
  ),
};

export default PickUpDropOff;
